import { ProfileStatusType } from '~/enums/accounts/profile-status-type.enum';
import type { ProfileModel } from '~/types';

export const hasAcceptedOnboarding = (profiles: ProfileModel[] = []): boolean =>
  profiles.some((profile) => profile?.Status?.Type === ProfileStatusType.Accepted);
